import _ from 'lodash'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import i18n from 'utils/i18n'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { View } from 'react-native'
import DraggableFlatList from 'react-native-draggable-flatlist'
import { constantsActive } from 'utils/constants/constants'
import ThemedDivider from 'components/atoms/ThemedDivider'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import React, { useEffect, useState } from 'react'
import ObjectRoom from 'utils/objects/room'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import Translate from 'utils/translate'
import { listArrow } from 'styles/list'
import HelperString from 'utils/helper-string'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationManagementRoomPositions from 'graphql/mutations/management/MutationManagementRoomPositions'
import { layoutStyles } from 'styles/layout'
import ListItem from 'components/atoms/ListItem'

const FloorRooms = ({ buildingGuid, floor }) => {
	
	const navigation = useNavigation();
	
	const [ isDraggable, setIsDraggable ] = useState(false )
	const [ isSaving, setIsSaving ] = useState(false )
	
	const [ rooms, setRooms ] = useState( ObjectRoom.order( _.get( floor, 'rooms', [] ) ) )
	const [ draggedRooms, setDraggedRooms ] = useState( [] )
	
	const [ searchValue, setSearchValue ] = useState('')
	
	// reload when more floors are added
	useEffect( () => {
		setRooms( ObjectRoom.order( _.get( floor, 'rooms', [] ) ) )
	}, [ _.size( _.get( floor, 'rooms', [] ) ) ] )
	
	const toggleDraggable = () => {
		setIsDraggable( !isDraggable )
	}
	
	const openRoom = ( item= {} ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_BUILDINGS_ROOM, {
			buildingGuid: buildingGuid,
			floorGuid: floor.guid,
			roomGuid: item.guid
		});
	}
	
	const createRoom = () => {
		openRoom( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openRoom }
			/>
		)
	}
	
	const renderDraggableItem = ( { item, index, drag, isActive } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				drag={ drag }
				dragIsActive={ isActive }
			/>
		)
	}
	
	const mutationRoomPositions = () => {
		const variables = {};
		variables['room_positions'] = _.map( draggedRooms, (object, key) => {
			return (
				{
					room_guid: object.guid,
					position: key
				}
			);
		})
		
		new GraphqlBuilder()
			.addQuery( 'mutation_room_position', MutationManagementRoomPositions, variables )
			.setOnStart( () => {
				setIsSaving( true )
			})
			.setOnSuccess( result => {
				const newRooms = ObjectRoom.order(
					_.map( rooms, (item) => {
						return _.merge( item, _.find( result.mutation_room_position.room_positions, { 'guid': item.guid } ) );
					})
				);
				
				setIsSaving( false )
				setIsDraggable( false )
				setDraggedRooms( [] )
				setRooms( newRooms )
			})
			.setOnError( result => {
				setIsSaving( false )
			})
			.execute()
	}
	
	const filters = _.size( searchValue ) > 2 ? [ {field: 'name', kind: 'contains', value: searchValue } ] : null;
	
	const header = (
		<>
			<ManagementHeader
				inputs={[
					{
						placeholder: i18n.t( 'management:pages.buildings.floor.input_search'),
						onChangeText: _.debounce( setSearchValue, 400 )
					}
				]}
				dragButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.ROOMS ) ? {
					onPress: toggleDraggable,
					drag: isDraggable,
					save: mutationRoomPositions,
					isSaving: isSaving
				} : null }
				addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.ROOMS ) ? {
					onPress: createRoom
				} : null }
			/>
		</>
	);
	
	return (
		<Choose>
			<When condition={ isDraggable }>
				<ThemedBlock
					header={ header }
					shadow>
					
					<View style={ layoutStyles.flexOne }>
						<DraggableFlatList
							data={ _.filter( !_.isEmpty( draggedRooms ) ? draggedRooms : rooms, { active: constantsActive.YES } ) }
							renderItem={ renderDraggableItem.bind( this ) }
							ItemSeparatorComponent={ ThemedDivider }
							keyExtractor={ (item, index) => {
								return HelperString.hash(`draggable-item`, item.guid);
							} }
							onDragEnd={({ data }) => {
								return setDraggedRooms(data);
							} }
						/>
					</View>
				</ThemedBlock>
			</When>
			<Otherwise>
				<ManagementGroupedThemeList
					header={ header }
					items={ rooms }
					renderItem={ renderItem.bind( this ) }
					groupByKey={ 'active' }
					filters={ filters }
					groupByValues={ [
						constantsActive.YES,
						constantsActive.NO
					] }
				/>
			</Otherwise>
		</Choose>
	);
}

export default FloorRooms
